/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, DIC){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';
	let lang = location.pathname.split('/')[1];
	// if(lang === 'ph') {
	// 	lang = 'en';
	// } else if(lang === 'bd') {
	// 	lang = 'en';
	// } else if(lang === 'vn') {
	// 	lang = 'en';
	// } else if(lang === 'my') {
	// 	lang = 'en';
	// }
	// 全角→半角変換
	const textConversion = ($text) => {
		return $text.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
		});
	};
	const tblScroll = () => {
		let tblWrapW = $('.finderCoating-tblWrap').outerWidth();
		let tblW = $('.finderCoating-tbl').outerWidth();
		let tblbar = tblW - tblWrapW;
		let left = $('.js-finderCoating-table-scroll-left');
		let right = $('.js-finderCoating-table-scroll-right');
		if(tblbar > 0) {
			$('.finderCoating-tbl-scroll').addClass(a);
		} else {
			$('.finderCoating-tbl-scroll').removeClass(a);
		}
		left.on('click', function(){
			$('.finderCoating-tblWrap').scrollLeft(0);
		});
		right.on('click', function(){
			$('.finderCoating-tblWrap').scrollLeft(tblbar);
		});
	};
	const menu = () => {
		if($('.js-finderCoating-menu-btn').length) {
			const menuBtn = $('.js-finderCoating-menu-btn');
			const menuBtnSp = $('.js-finderCoating-menu-btn-sp');
			const block = $('.finderCoating-column');
			let flag = false;
			let scrollTopNow;

			menuBtn.on('click', function(){
				$(this).toggleClass(a);
				block.toggleClass(a);
				tblScroll();
			});
			menuBtnSp.on('click', function(){
				if(!flag) {
					scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
					menuBtnSp.addClass(a);
					block.addClass(a);
					$('.container').css({
						position: 'fixed',
						width: '100%',
						top: -1 * scrollTopNow,
						left: 0
					});
					$('.header').css('height','60px');
					$('body').addClass(f);
					flag = true;
				} else {
					menuBtnSp.removeClass(a);
					block.removeClass(a);
					$('.container').css({
						position: 'static',
					});
					$('.header').css('height','120px');
					$('body').removeClass(f);
					$(window).scrollTop(scrollTopNow);
					flag = false;
				}
				// console.log(flag);
			});
			$(window).scroll(function(e){
				var $this = $(e.currentTarget);
				var $tbl = $('.finderCoating-tblWrap');
				var $tblHeight = $('.finderCoating-tblWrap').height();
				var tblPos = $tbl.offset().top;
				var thisScroll = $this.scrollTop() + 88;
				if($(window).width() < 1024) {
					thisScroll = $this.scrollTop() + 60;
				}
				if(tblPos <= thisScroll) {
					menuBtnSp.addClass(f);
					if(($tblHeight + tblPos - 288) <= thisScroll) {
						$('.finderCoating-tbl-scroll').removeClass(f);
					} else {
						$('.finderCoating-tbl-scroll').addClass(f);
					}
				} else {
					menuBtnSp.removeClass(f);
					$('.finderCoating-tbl-scroll').removeClass(f);
				}
			});
		}
	};
	const productSearch = () => {
		if($('.finderCoating-tblWrap').length) {
			// 変数定義
			const getJSONproduct = (_num,_parameter) => {
				return $.getJSON(`/${lang}/ajax/coating_product.json?rt_bn_product_list_skip=${_num}${_parameter}`);
			};
			const getJSONproductcsv = (_parameter) => {
				return $.getJSON(`/${lang}/ajax/coating_product_csv.json${_parameter}`);
			};
			// もっと見るボタン
			const moreBtn = $('.js-finderCoating-more-btn');
			let count = 0;
			// タグ部分
			const block = $('.finderCoating-label');
			const tag = $('.js-finderCoating-tag');
			const release = $('.js-finderCoating-release');
			// jsonset
			const jsonset = ($num,$parameter) => {
				$('.finderCoating-columnWrap').css('pointer-events', 'none');
				$('.js-finderCoating-loadingWrap').removeClass(a);
				if(count == 0) {
					$('.finderCoating-tbl tbody tr').remove();
				}
				getJSONproduct($num,$parameter).then((data) => {
					console.log(data,'data',);
					console.log($num,$parameter,'$num,$parameter');
					// console.log(data.total,'datatotal');
					for(let i = 0; i < data.rt_bn_product_list.length; i++) {
						let product;
						// console.log(data.rt_bn_product_list[i].cf_pco_q_pickup,'data.rt_bn_product_list[i].cf_pco_q_pickup', (!data.rt_bn_product_list[i].cf_pco_q_pickup));
						// newアイコン
						if(!data.rt_bn_product_list[i].cf_pco_q_pickup) {
							if(!(data.rt_bn_product_list[i]._key)) {
								product = '<td>'+data.rt_bn_product_list[i].cf_pco_trade_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+' '+data.rt_bn_product_list[i].cf_pco_product_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>';
							} else {
								product = '<td><a href="/'+lang+'/products/finder_coating/'+data.rt_bn_product_list[i]._key+'.html" class="td_under di_iblock" target="_blank">'+data.rt_bn_product_list[i].cf_pco_trade_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+' '+data.rt_bn_product_list[i].cf_pco_product_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</a></td>';
							}
						} else {
							if(!data.rt_bn_product_list[i].cf_pco_q_pickup.length) {
								if(!(data.rt_bn_product_list[i]._key)) {
									product = '<td>'+data.rt_bn_product_list[i].cf_pco_trade_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+' '+data.rt_bn_product_list[i].cf_pco_product_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>';
								} else {
									product = '<td><a href="/'+lang+'/products/finder_coating/'+data.rt_bn_product_list[i]._key+'.html" class="td_under di_iblock" target="_blank">'+data.rt_bn_product_list[i].cf_pco_trade_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+' '+data.rt_bn_product_list[i].cf_pco_product_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</a></td>';
								}
							} else {
								if(!(data.rt_bn_product_list[i]._key)) {
									product = '<td>'+
									'<span class="finderCoating-new mb5"><span>New</span></span>'+
									data.rt_bn_product_list[i].cf_pco_trade_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+' '+data.rt_bn_product_list[i].cf_pco_product_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>';
								} else {
									product = '<td><a href="/'+lang+'/products/finder_coating/'+data.rt_bn_product_list[i]._key+'.html" class="td_under di_iblock" target="_blank">'+
									'<span class="finderCoating-new mb5"><span>New</span></span>'+
									data.rt_bn_product_list[i].cf_pco_trade_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+' '+data.rt_bn_product_list[i].cf_pco_product_name.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</a></td>';
								}
							}
						}
						$('.finderCoating-tbl').append('<tr>'+
						product+
						'<td class="ta_center">'+data.rt_bn_product_list[i].cf_pco_resin.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'<td class="ta_center">'+data.rt_bn_product_list[i].cf_pco_technology.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'<td>'+data.rt_bn_product_list[i].cf_pco_solvent.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'<td class="ta_center">'+data.rt_bn_product_list[i].cf_pco_non_volatile.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'<td class="ta_center">'+data.rt_bn_product_list[i].cf_pco_viscosity.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'<td class="ta_center">'+data.rt_bn_product_list[i].cf_pco_acid_value.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'<td class="ta_center">'+data.rt_bn_product_list[i].cf_pco_oh_value.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'<td class="ta_center">'+data.rt_bn_product_list[i].cf_pco_eew.replace(/\n/g,"<br>").replace(/℃/g,"&deg;C")+'</td>'+
						'</tr>');
					}
					// $('.js-finderCoating-skip').text(data.skip + data.rt_bn_product_list.length);
					$('.js-finderCoating-skip').text(data.total);
					$('.js-finderCoating-total').text(data.total);
					console.log(data.skip,data.rt_bn_product_list.length,data.total);
					console.log(data.skip,data.rt_bn_product_list.length,data.total);
					if(!(data.total > (data.skip + data.rt_bn_product_list.length))) {
						moreBtn.removeClass(a);
					} else {
						moreBtn.addClass(a);
					}
					$('.finderCoating-columnWrap').css('pointer-events', 'auto');
					$('.js-finderCoating-loadingWrap').addClass(a);
				});
			};
			// 各パラメータ格納用
			const parmeterCheck = () => {
				let parmeter = '';
				let p_c_region = '';
				let p_c_application = '';
				let p_c_technology = '';
				let p_c_resin_type = '';
				let p_c_drying_process = '';
				let p_c_features = '';
				let p_c_pickup = '';
				for(let l=0; l<$('input[name="p_c_region"]').length; l++) {
					if ($('input[name="p_c_region"]').eq(l).prop('checked')) {
						p_c_region += '&p_c_region='+$('input[name="p_c_region"]').eq(l).val();
					}
				}
				for(let l=0; l<$('input[name="p_c_application"]').length; l++) {
					if ($('input[name="p_c_application"]').eq(l).prop('checked')) {
						p_c_application += '&p_c_application='+$('input[name="p_c_application"]').eq(l).val();
					}
				}
				for(let l=0; l<$('input[name="p_c_technology"]').length; l++) {
					if ($('input[name="p_c_technology"]').eq(l).prop('checked')) {
						p_c_technology += '&p_c_technology='+$('input[name="p_c_technology"]').eq(l).val();
					}
				}
				for(let l=0; l<$('input[name="p_c_resin_type"]').length; l++) {
					if ($('input[name="p_c_resin_type"]').eq(l).prop('checked')) {
						p_c_resin_type += '&p_c_resin_type='+$('input[name="p_c_resin_type"]').eq(l).val();
					}
				}
				for(let l=0; l<$('input[name="p_c_drying_process"]').length; l++) {
					if ($('input[name="p_c_drying_process"]').eq(l).prop('checked')) {
						p_c_drying_process += '&p_c_drying_process='+$('input[name="p_c_drying_process"]').eq(l).val();
					}
				}
				for(let l=0; l<$('input[name="p_c_features"]').length; l++) {
					if ($('input[name="p_c_features"]').eq(l).prop('checked')) {
						p_c_features += '&p_c_features='+$('input[name="p_c_features"]').eq(l).val();
					}
				}
				for(let l=0; l<$('input[name="p_c_pickup"]').length; l++) {
					if ($('input[name="p_c_pickup"]').eq(l).prop('checked')) {
						p_c_pickup += '&p_c_pickup='+$('input[name="p_c_pickup"]').eq(l).val();
					}
				}
				parmeter += p_c_region;
				parmeter += p_c_application;
				parmeter += p_c_technology;
				parmeter += p_c_resin_type;
				parmeter += p_c_drying_process;
				parmeter += p_c_features;
				parmeter += p_c_pickup;

				// キーワード設定
				let p_keyword = '';
				// （U+FF0D）全角マイナス
				// （U+30FC）全角の長音
				// （U+FF70）半角カタカナの長音記号
				// 　↓
				// 半角のハイフン「-（U+002D）」に変換
				// スペース（全角・半角）は「+」に変換して+で区切って配列化
				let keywordlist = textConversion($('input[name="p_keyword"]').val()).replace(/－/g,'-').replace(/ー/g,'-').replace(/ｰ/g,'-').replace(/　/g, ' ').split(/\s+/);
				// console.log(keywordlist,'keywordlist');
				for(let m=0; m<keywordlist.length; m++) {
					if (m == 0) {
						p_keyword += '&p_keyword_1='+encodeURIComponent(keywordlist[m]);
					} else if (m == 1) {
						p_keyword += '&p_keyword_2='+encodeURIComponent(keywordlist[m]);
					} else if (m == 2) {
						p_keyword += '&p_keyword_3='+encodeURIComponent(keywordlist[m]);
					} else if (m == 3) {
						p_keyword += '&p_keyword_4='+encodeURIComponent(keywordlist[m]);
					} else if (m == 4) {
						p_keyword += '&p_keyword_5='+encodeURIComponent(keywordlist[m]);
					} else if (m == 5) {
						p_keyword += '&p_keyword_6='+encodeURIComponent(keywordlist[m]);
					} else if (m == 6) {
						p_keyword += '&p_keyword_7='+encodeURIComponent(keywordlist[m]);
					} else if (m == 7) {
						p_keyword += '&p_keyword_8='+encodeURIComponent(keywordlist[m]);
					} else if (m == 8) {
						p_keyword += '&p_keyword_9='+encodeURIComponent(keywordlist[m]);
					} else if (m == 9) {
						p_keyword += '&p_keyword_10='+encodeURIComponent(keywordlist[m]);
					}
				}
				parmeter += p_keyword;

				console.log(parmeter,'parmeter');
				return parmeter;
			};
			// 初期表示用（パラメーターチェック）
			const urlparmeterCheck = () => {
				var search = location.search;
				search = search.replace('?', '');
				var ar_search = search.split('&');
				var param = '';
				var title = '';
				for(let l=0; l<ar_search.length; l++) {
					// console.log(ar_search[l],'aaa');
					if (ar_search[l].indexOf('title=') != -1) {
						title = decodeURI(ar_search[l].replace('title=',''))+'　';
					}
					if (ar_search[l].indexOf('p_c_resin_type=') != -1) {
						param += '&'+ar_search[l];
					} else if (ar_search[l].indexOf('p_c_region=') != -1) {
						param += '&'+ar_search[l];
					} else if (ar_search[l].indexOf('p_c_application=') != -1) {
						param += '&'+ar_search[l];
					} else if (ar_search[l].indexOf('p_c_technology=') != -1) {
						param += '&'+ar_search[l];
					} else if (ar_search[l].indexOf('p_c_drying_process=') != -1) {
						param += '&'+ar_search[l];
					} else if (ar_search[l].indexOf('p_c_features=') != -1) {
						param += '&'+ar_search[l];
					} else if (ar_search[l].indexOf('p_c_pickup=') != -1) {
						param += '&'+ar_search[l];
					} else if (ar_search[l].indexOf('p_keyword=') != -1) {
						// 検索ボックスキーワード設定
						$('input[name="p_keyword"]').val(textConversion(decodeURIComponent((ar_search[l]).replace('p_keyword=','').replace(/\+/g, ' '))));
						// json呼び出しキーワード設定
						let p_keyword = '';
						let keywordlist = textConversion($('input[name="p_keyword"]').val()).replace(/－/g,'-').replace(/ー/g,'-').replace(/ｰ/g,'-').replace(/　/g, ' ').split(/\s+/);
						// console.log(keywordlist,'keywordlist');
						for(let m=0; m<keywordlist.length; m++) {
							if (m == 0) {
								p_keyword += '&p_keyword_1='+encodeURIComponent(keywordlist[m]);
							} else if (m == 1) {
								p_keyword += '&p_keyword_2='+encodeURIComponent(keywordlist[m]);
							} else if (m == 2) {
								p_keyword += '&p_keyword_3='+encodeURIComponent(keywordlist[m]);
							} else if (m == 3) {
								p_keyword += '&p_keyword_4='+encodeURIComponent(keywordlist[m]);
							} else if (m == 4) {
								p_keyword += '&p_keyword_5='+encodeURIComponent(keywordlist[m]);
							} else if (m == 5) {
								p_keyword += '&p_keyword_6='+encodeURIComponent(keywordlist[m]);
							} else if (m == 6) {
								p_keyword += '&p_keyword_7='+encodeURIComponent(keywordlist[m]);
							} else if (m == 7) {
								p_keyword += '&p_keyword_8='+encodeURIComponent(keywordlist[m]);
							} else if (m == 8) {
								p_keyword += '&p_keyword_9='+encodeURIComponent(keywordlist[m]);
							} else if (m == 9) {
								p_keyword += '&p_keyword_10='+encodeURIComponent(keywordlist[m]);
							}
						}
						param += p_keyword;
					}
					for(let i=0; i<$('input').length; i++) {
						if($('input').eq(i).val() === (ar_search[l]).replace('p_c_resin_type=','')) {
							$('input').eq(i).prop('checked', true);
							for(let j=0; j<tag.length; j++) {
								if($('input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(j).find('span').text()) {
									tag.eq(j).addClass(a);
								}
							}
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggle').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').css('display','block');
						} else if($('input').eq(i).val() === (ar_search[l]).replace('p_c_region=','')) {
							$('input').eq(i).prop('checked', true);
							for(let j=0; j<tag.length; j++) {
								if($('input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(j).find('span').text()) {
									tag.eq(j).addClass(a);
								}
							}
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggle').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').css('display','block');
						} else if($('input').eq(i).val() === (ar_search[l]).replace('p_c_application=','')) {
							$('input').eq(i).prop('checked', true);
							for(let j=0; j<tag.length; j++) {
								if($('input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(j).find('span').text()) {
									tag.eq(j).addClass(a);
								}
							}
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggle').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').css('display','block');
						} else if($('input').eq(i).val() === (ar_search[l]).replace('p_c_technology=','')) {
							$('input').eq(i).prop('checked', true);
							for(let j=0; j<tag.length; j++) {
								if($('input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(j).find('span').text()) {
									tag.eq(j).addClass(a);
								}
							}
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggle').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').css('display','block');
						} else if($('input').eq(i).val() === (ar_search[l]).replace('p_c_drying_process=','')) {
							$('input').eq(i).prop('checked', true);
							for(let j=0; j<tag.length; j++) {
								if($('input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(j).find('span').text()) {
									tag.eq(j).addClass(a);
								}
							}
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggle').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').css('display','block');
						} else if($('input').eq(i).val() === (ar_search[l]).replace('p_c_features=','')) {
							$('input').eq(i).prop('checked', true);
							for(let j=0; j<tag.length; j++) {
								if($('input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(j).find('span').text()) {
									tag.eq(j).addClass(a);
								}
							}
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggle').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').addClass(a);
							$('input').eq(i).parents('.finderCoating-toggleWrap').find('.js-toggleBlock').css('display','block');
						} else if($('input').eq(i).val() === (ar_search[l]).replace('p_c_pickup=','')) {
							$('input').eq(i).prop('checked', true);
							for(let j=0; j<tag.length; j++) {
								if($('input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(j).find('span').text()) {
									tag.eq(j).addClass(a);
								}
							}
						}
					}
					if($('input[name="p_c_resin_type"]').filter(":checked").length == $('input[name="p_c_resin_type"]').length) {
						$('.p_c_resin_type_all').prop('checked', true);
					}
				}
				if(!(block.find('.is-active').length)) {
					block.addClass('is-hidden');
				} else {
					block.removeClass('is-hidden');
				}
				$('h1.mod-head01').prepend(title);
				jsonset(0,param);
			};
			// 初期表示
			urlparmeterCheck();
			count = 0;
			// タグ部分初期表示・イベント
			if(!(block.find('.is-active').length)) {
				block.addClass('is-hidden');
			}
			// キーワード設定
			$('.js-finder_coating-keyword-btn').on('click', function(){
				count = 0;
				jsonset(0,parmeterCheck());
			});
			// 検索部分でエンターを押したときにボタンクリックと同じ処理を追加
			if(!($(window).width() < 1025)) {
				$('input[name="p_keyword"]').keypress(function(e){
					if(e.which === 13) {
						count = 0;
						jsonset(0,parmeterCheck());
						return false;
					}
				});
			}
			$('.p_c_resin_type_all').change(function() {
				if($(this).prop('checked')) {
					$('input[name="p_c_resin_type"]').prop('checked', true);
				} else {
					$('input[name="p_c_resin_type"]').prop('checked', false);
				}
				for(let i=0; i<$('.js-checkbox input').length; i++) {
					if ($('.js-checkbox input').eq(i).prop('checked')) {
						for(let k=0; k<tag.length; k++) {
							if($('.js-checkbox input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(k).find('span').text()) {
								tag.eq(k).addClass(a);
							}
						}
					} else {
						for(let k=0; k<tag.length; k++) {
							if($('.js-checkbox input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(k).find('span').text()) {
								tag.eq(k).removeClass(a);
							}
						}
					}
				}
				if(!(block.find('.is-active').length)) {
					block.addClass('is-hidden');
				} else {
					block.removeClass('is-hidden');
				}
				count = 0;
				jsonset(0,parmeterCheck());
			});
			$('.js-checkbox input').change(function() {
				for(let i=0; i<tag.length; i++) {
					if ($(this).prop('checked')) {
						if($(this).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(i).find('span').text()) {
							tag.eq(i).addClass(a);
						}
					} else {
						if($(this).next('.mod-checkbox-text').find('.rt_tag_name').text() === tag.eq(i).find('span').text()) {
							tag.eq(i).removeClass(a);
						}
					}
				}
				if($('input[name="p_c_resin_type"]').filter(":checked").length == $('input[name="p_c_resin_type"]').length) {
					$('.p_c_resin_type_all').prop('checked', true);
				} else {
					$('.p_c_resin_type_all').prop('checked', false);
				}
				if(!(block.find('.is-active').length)) {
					block.addClass('is-hidden');
				} else {
					block.removeClass('is-hidden');
				}
				count = 0;
				jsonset(0,parmeterCheck());
			});
			tag.on('click', function(){
				$(this).removeClass(a);
				for(let i=0; i<$('.js-checkbox input').length; i++) {
					if($('.js-checkbox input').eq(i).next('.mod-checkbox-text').find('.rt_tag_name').text() === $(this).find('span').text()) {
						$('.js-checkbox input').eq(i).prop('checked', false);
					}
				}
				if(!(block.find('.is-active').length)) {
					block.addClass('is-hidden');
				} else {
					block.removeClass('is-hidden');
				}
				count = 0;
				jsonset(0,parmeterCheck());
			});
			release.on('click', function(){
				for(let i=0; i<$('input').length; i++) {
					$('input').eq(i).prop('checked', false);
				}
				for(let l=0; l<tag.length; l++) {
					tag.eq(l).removeClass(a);
				}
				block.addClass('is-hidden');
				count = 0;
				jsonset(0,parmeterCheck());
			});
			// もっと見る部分イベント
			moreBtn.on('click', function(){
				count += 30;
				jsonset(count,parmeterCheck());
			});
			// csvダウンロード
			//jsonをcsv文字列に編集する
			function jsonToCsv(json, delimiter) {
				var header = Object.keys(json[0]).join(delimiter) + "\n";
				var body = json.map(function(d){
					return Object.keys(d).map(function(key) {
						// ダブルクォートで囲む
						let finKey = '"'+d[key]+'"';
						return finKey;
					}).join(delimiter);
				}).join("\n");
				return header + body;
			}
			//csv変換
			function exportCSV(items, delimiter, filename) {
				//文字列に変換する
				var csv = jsonToCsv(items, delimiter);
				//拡張子
				var extention = delimiter==","?"csv":"tsv";
				//出力ファイル名
				var exportedFilenmae = (filename  || 'export') + '.' + extention;
				//BLOBに変換
				var bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
				var blob = new Blob([bom,csv], { type: 'text/csv;charset=utf-8;' });
				if (navigator.msSaveBlob) { // for IE 10+
					navigator.msSaveBlob(blob, exportedFilenmae);
				} else {
					//anchorを生成してclickイベントを呼び出す。
					var link = document.createElement("a");
					if (link.download !== undefined) {
						var url = URL.createObjectURL(blob);
						link.setAttribute("href", url);
						link.setAttribute("download", exportedFilenmae);
						link.style.visibility = 'hidden';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
				}
			}
			$('.js-finderCoating-csv').on('click', function(){
				let csvParm = '?'+parmeterCheck().slice(1);
				// console.log(csvParm,'csvParm');
				getJSONproductcsv(csvParm).then((data) => {
					// console.log(data.rt_bn_product_list,'data');
					let itemList = [];
					for(let i = 0; i < data.rt_bn_product_list.length; i++) {
						itemList[i] = {
							Product: data.rt_bn_product_list[i].cf_pco_trade_name.replace(/\"/g,"")+' '+data.rt_bn_product_list[i].cf_pco_product_name.replace(/\"/g,""),
							Resin: data.rt_bn_product_list[i].cf_pco_resin.replace(/\"/g,""),
							Technology: data.rt_bn_product_list[i].cf_pco_technology.replace(/\"/g,""),
							Solvent: data.rt_bn_product_list[i].cf_pco_solvent.replace(/\"/g,""),
							Non_volatile: data.rt_bn_product_list[i].cf_pco_non_volatile.replace(/\"/g,""),
							Viscosity: data.rt_bn_product_list[i].cf_pco_viscosity.replace(/\"/g,""),
							Acid_value: data.rt_bn_product_list[i].cf_pco_acid_value.replace(/\"/g,""),
							OH_value: data.rt_bn_product_list[i].cf_pco_oh_value.replace(/\"/g,""),
							EEW: data.rt_bn_product_list[i].cf_pco_eew.replace(/\"/g,""),
						};
					}
					// console.log(itemList,'itemList');
					exportCSV(itemList,',', 'finderCoating_products');
				});
			});
		}
	};
	const detailTbl = () => {
		if($('.finderCoating-detail .mod-tbl02 td').length) {
			for(let i=0; i<$('.finderCoating-detail .mod-tbl02 td').length; i++) {
				if(!($('.finderCoating-detail .mod-tbl02 td').eq(i).html().replace(/^\s+/, '').length)) {
					$('.finderCoating-detail .mod-tbl02 td').eq(i).parents('tr').addClass('di_none');
				}
				let textReplace = $('.finderCoating-detail .mod-tbl02 td').eq(i).text().replace(/^\s+/, '').replace(/℃/g,"&deg;C");
				$('.finderCoating-detail .mod-tbl02 td').eq(i).html(textReplace);
			}
		}
		if($('.js-finderCoating-detail-applications').length) {
			let pId = location.pathname.split('/')[4].replace('.html','');
			const getJSONdetail = () => {
				return $.getJSON(`/${lang}/ajax/coating_product/${pId}.json`);
			};
			getJSONdetail().then((data) => {
				// console.log(data.rt_bn_product_info,'data');
				// console.log(data.rt_bn_product_info[0].cf_pco_q_application,'data2');
				for(let i=0; i<data.rt_bn_product_info[0].cf_pco_q_application.length; i++) {
					let a_text;
					if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_plastic') {
						a_text = 'Plastic coatings';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_metal') {
						a_text = 'Metal coatings';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_electronics') {
						a_text = 'Home appliances & Consumer electronics';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_automotive') {
						a_text = 'Automotive exterior/Motorcycle';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_architectural') {
						a_text = 'Architectural/Decorative coatings';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_wood') {
						a_text = 'Wood coatings';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_automotive_refinishing') {
						a_text = 'Automotive refinishing';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_general_industrial') {
						a_text = 'General industrial';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_coil_can') {
						a_text = 'Coil & can coating';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_paper_leather_textile') {
						a_text = 'Paper/Leather/textile coatings';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_heavyduty_machinery') {
						a_text = 'Heavy duty／machinery';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_additive_modifier') {
						a_text = 'Additive/modifier';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_dtm') {
						a_text = 'DTM';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_glass') {
						a_text = 'Glass coatings';
					} else if(data.rt_bn_product_info[0].cf_pco_q_application[i] === 'ap_resist') {
						a_text = 'Resist coatings';
					}
					let applications = ', ' + a_text;
					if(i === 0) {
						applications = a_text;
					}
					// $('.js-finderCoating-detail-applications').css('word-break','break-all');
					$('.js-finderCoating-detail-applications').append(applications);
				}
				for(let l=0; l<data.rt_bn_product_info[0].cf_pco_q_feature.length; l++) {
					let f_text;
					if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_chemical_resistance') {
						f_text = 'Chemical resistance';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_appearance') {
						f_text = 'Appearance';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_fast_drying') {
						f_text = 'Fast drying';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_hardness') {
						f_text = 'Hardness';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_weather_resistance') {
						f_text = 'Weather resistance';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_pigment_dispersibility') {
						f_text = 'Pigment dispersibility';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_flexibility') {
						f_text = 'Flexibility';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_anti_corrosion') {
						f_text = 'Anti-corrosion';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_water_humidity_resistance') {
						f_text = 'Water/humidity resistance';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_btx_free') {
						f_text = 'BTX free';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_metallic_pigment_orientation') {
						f_text = 'Metallic pigment orientation';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_high_solids') {
						f_text = 'High-solids';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_anti_staining') {
						f_text = 'Anti-staining';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_abrasion_resistance') {
						f_text = 'Abrasion resistance';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_heat_resistance') {
						f_text = 'Heat resistance';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_anti_blocking') {
						f_text = 'Anti-blocking';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_low_temperature_curing') {
						f_text = 'Low temperature curing';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_adhesion_pp') {
						f_text = 'Adhesion to PP';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_lightfastness') {
						f_text = 'Lightfastness';
					} else if(data.rt_bn_product_info[0].cf_pco_q_feature[l] === 'fe_self_healing') {
						f_text = 'Self-healing';
					}
					let feature =  ', ' + f_text;
					if(l === 0) {
						feature = f_text;
					}
					// $('.js-finderCoating-detail-key_features').css('word-break','break-all');
					$('.js-finderCoating-detail-key_features').append(feature);
				}
			});
		}
	};
	menu();
	tblScroll();
	$(window).resize(function() {
		tblScroll();
	});
	productSearch();
	detailTbl();
})(window.jQuery, window.DIC);
